var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8284 21.5693C13.7042 21.0877 13.4532 20.6482 13.1015 20.2966C12.7498 19.9449 12.3103 19.6939 11.8288 19.5696L3.29145 17.3682C3.14579 17.3268 3.0176 17.2391 2.92632 17.1183C2.83503 16.9975 2.78564 16.8502 2.78564 16.6988C2.78564 16.5474 2.83503 16.4001 2.92632 16.2793C3.0176 16.1585 3.14579 16.0708 3.29145 16.0295L11.8288 13.8266C12.3102 13.7025 12.7495 13.4517 13.1012 13.1002C13.4529 12.7488 13.704 12.3096 13.8284 11.8283L16.0299 3.29099C16.0708 3.14476 16.1585 3.01593 16.2795 2.92416C16.4004 2.83239 16.5481 2.78271 16.7 2.78271C16.8518 2.78271 16.9995 2.83239 17.1205 2.92416C17.2414 3.01593 17.3291 3.14476 17.37 3.29099L19.5701 11.8283C19.6943 12.3099 19.9453 12.7494 20.297 13.1011C20.6487 13.4527 21.0882 13.7038 21.5698 13.828L30.1071 16.0281C30.2539 16.0686 30.3834 16.1561 30.4756 16.2773C30.5679 16.3984 30.6179 16.5465 30.6179 16.6988C30.6179 16.8511 30.5679 16.9992 30.4756 17.1203C30.3834 17.2415 30.2539 17.329 30.1071 17.3695L21.5698 19.5696C21.0882 19.6939 20.6487 19.9449 20.297 20.2966C19.9453 20.6482 19.6943 21.0877 19.5701 21.5693L17.3686 30.1066C17.3277 30.2529 17.2401 30.3817 17.1191 30.4735C16.9981 30.5652 16.8504 30.6149 16.6986 30.6149C16.5467 30.6149 16.399 30.5652 16.2781 30.4735C16.1571 30.3817 16.0695 30.2529 16.0285 30.1066L13.8284 21.5693Z",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8315 4.1748V9.7411",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6146 6.95776H25.0483",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56641 23.6567V26.4399",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95795 25.0482H4.1748",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmart);
export default __webpack_public_path__ + "static/media/smart.163a9c5646bf097b0ddb7343a871088e.svg";
export { ForwardRef as ReactComponent };